<pm-dialog
  dialogTitle="ANALYSIS.EXPORT.TITLE"
  [secondaryCtaButtonConfig]="{ text: 'COMMON.CLOSE' }"
  [primaryCtaButtonConfig]="primaryCtaButtonConfig()"
>
  <div class="flex flex-col gap-4">
    <pm-tabs-group
      [options]="tabOptions"
      [initialValue]="dialogData?.initialTab"
      [fullWidth]="true"
      [queryKey]="undefined"
      (handleClick)="setActiveTab($event)"
    />
    @switch (activeTab()) {
      @case (ExportTab.NEW) {
        <p class="text-sm text-content-secondary">
          {{ 'ANALYSIS.EXPORT.DESCRIPTION' | translate }}
        </p>
      }
      @case (ExportTab.LIST) {
        @if (exports.hasValue()) {
          <pm-export-downloads-list
            [exports]="exports.value()"
            [(selectedExportId)]="selectedExportId"
          />
        }
      }
    }
  </div>
</pm-dialog>
